import {SEARCH_RESULTS_BASE_PATH, PAGE_TITLES, CAMPAIGNS_BASE_PATH, CAMPAIGN_TEMPLATE_DETAILS_PATH} from '_app/mediahub/mediaHubConstants';
import {appConfigService, linkService} from '_app/services';
import {sectionConstants} from '_app/utils';

export const getPrevPageTitle = (pathName) => {
	const pageTitleKey = Object.keys(PAGE_TITLES);
	let prevPageTitle = pageTitleKey[0];

	if (pathName !== '/') {
		if (pathName.includes(SEARCH_RESULTS_BASE_PATH)) {
			prevPageTitle = pageTitleKey[1];
		} else if (pathName.includes(pageTitleKey[2])) {
			prevPageTitle = pageTitleKey[2];
		} else {
			const matchingSection = Object.entries(sectionConstants.SECTION_NAMES)
				.find(sectionsEntries => sectionsEntries.find(section => pathName.includes(section)));

			if (matchingSection && matchingSection.length) {
				prevPageTitle = matchingSection[0];
			}
		}
	}

	return prevPageTitle;
};

export const getBackLinkTitle = (prevPage) => {
	let backLinkTitle = PAGE_TITLES.landing;

	if (prevPage) {
		const pageTitleKey = Object.keys(PAGE_TITLES);

		if (prevPage !== '/') {
			if (prevPage === pageTitleKey[1]) {
				backLinkTitle = PAGE_TITLES.globalSearch;
			} else if (prevPage === pageTitleKey[2]) {
				backLinkTitle = PAGE_TITLES.media;
			} else {
				const matchingSection = Object.entries(sectionConstants.SECTION_NAMES)
					.find(sectionsEntries => sectionsEntries.find(section => prevPage.includes(section)));

				if (matchingSection && matchingSection.length) {
					backLinkTitle = matchingSection[1];
				}
			}
		}
	}

	return backLinkTitle;
};

export const getLinkObject = (mediaItem, section, isCampaign, location, isPrefixRequired, exclureAnchor, startSection) => {
	let pathname = '';

	if (isCampaign && section === 1) {
		pathname = `${isPrefixRequired ? '#' : ''}${CAMPAIGNS_BASE_PATH}/${CAMPAIGN_TEMPLATE_DETAILS_PATH}/${mediaItem.ID}`;
	} else {
		pathname = `${exclureAnchor ? '/' : ''}${linkService.go(mediaItem, exclureAnchor)}`;
	}

	return `${pathname}/?prevPage=${getPrevPageTitle(location)}${startSection ? `&startSection=${startSection}` : ''}`;
};

export const getThumbnailUrl = thumbnailLink => {
	return thumbnailLink ? `${appConfigService.get('serverPath')}api/v1/StoredFile/${thumbnailLink}/download` :
		`${appConfigService.get('serverPath')}Content/no_image_uploaded.png`;
};